import * as React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { OpenregisterSearchModal } from "./components/OpenregisterSearchModal";
import { loadAndMapOpenRegisterRecordSaga } from "./sagas/loadAndMapOpenRegisterRecordSaga";
import { openSearchModalSaga } from "./sagas/openSearchModalSaga";
import { refreshOpenRegisterRecordSaga } from "./sagas/refreshOpenRegisterRecordSaga";
import { searchOpenRegisterRecordsSaga } from "./sagas/searchOpenRegisterRecordsSaga";

const components: Record<string, React.ComponentType<View> | undefined> = {
	OpenregisterSearchModal
};

function viewComponentProvider(name: string) {
	return components[name];
}

const openregisterSelectionModule = (): Module => ({
	id: "openregisterSelectionModule",
	views: () => viewComponentProvider,
	sagas: () => [
		openSearchModalSaga,
		searchOpenRegisterRecordsSaga,
		loadAndMapOpenRegisterRecordSaga,
		refreshOpenRegisterRecordSaga
	]
});

export default openregisterSelectionModule;
